import React, { Component } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import { toast } from "react-toastify";
import axios from "axios";
import useAutocomplete from "@material-ui/lab/useAutocomplete";
import NoSsr from "@material-ui/core/NoSsr";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import _apiData from "../../metaData";
let apiData = _apiData[0];
console.log(apiData, "apiData");
let self;
let selectedAppsNew = [];
let selectedRolesNew = [];

const InputWrapper = styled("div")`
  width: 300px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #40a9ff;
  }

  &.focused {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    font-size: 14px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`;

const Tag = styled(({ label, onDelete, ...props }) => (
  <div {...props}>
    <span>{label}</span>
    <CloseIcon onClick={onDelete} />
  </div>
))`
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: #40a9ff;
    background-color: #e6f7ff;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`;

const Listbox = styled("ul")`
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: #fff;
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected="true"] {
    background-color: #fafafa;
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li[data-focus="true"] {
    background-color: #e6f7ff;
    cursor: pointer;

    & svg {
      color: #000;
    }
  }
`;

export default class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentRole: "",
      searchText: "Search",
      searchData: {},
      showDetails: false,
      rolesList: [{title: "Client Agent", value: "CLNT_AGENT"}, {title: "Client Supervisor", value: "CLNT_SUPERVISOR"}, {title: "Client Verifier", value: "CLNT_VERIFIER"}]
    };
    self = this;
  }

  componentDidMount() {
    if(this.props.location.state && this.props.location.state.username){
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.props.location.state.username.split("_")[0] },
          headers: apiData.headers
        })
        .then(res => {
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }

  submitAgent(e) {
    // this.setState({
    //   agentRole: selectedRolesNew
    // });
    let selectedRoles = [...selectedRolesNew];
    let selectedRolesArray = [];
    selectedRoles.map(ele => {
      if(ele.value) {
        selectedRolesArray.push(ele.value);
      }
    })

    let roles = [];
    selectedRolesNew.map(ele => {
      if(ele.value){
        roles.push(ele.value);
      }
    })
    
    if (!selectedRolesArray.length) {
      toast.error("Please Select Role!", {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      console.log("submit..");
      let data = {};
      data.username = this.state.searchData.userName;
      data.user_type = roles;
      axios
        .put(apiData.userDetails.url, data, {
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "submit put res");
          if (res.data.ok) {
            toast.success("Edited Sucessfully!", {
              position: toast.POSITION.TOP_RIGHT
            });
            this.setState({
              showDetails: false,
              agentRole: ""
            });
          } else {
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }
  searchClick(e) {
    console.log(this.state.searchMobile, "mobile");
    this.setState({
      searchText: "Loading..."
    });
    if (this.state.searchMobile) {
      let params = {};
      params.username = this.state.searchMobile;
      console.log(params, "paraaamss");
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.state.searchMobile },
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "ress");
          this.setState({
            searchText: "Search"
          });
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("Please Enter Mobile/UserName !", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  render() {
    console.log(this.state.agentRole, "agentRole");
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">Edit Agents</h6>

        <div className="row data-row">
          <div className="col-md-3 label-class">
            <span className="label-text">Mobile Number</span>
          </div>
          <div className="col-md-7 select-bordered-div">
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                // type="number"
                // label="Select State"
                name="state"
                label="Mobile Number"
                onChange={e => {
                  this.setState({ searchMobile: e.target.value });
                }}
                // select
                // eslint-disable-next-line react/jsx-sort-props
                // SelectProps={{ native: true }}
                // value={values.state}
                variant="outlined"
              ></TextField>
            </Grid>
          </div>
          <div className="col-md-2" id="search-btn">
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={this.searchClick.bind(this)}
            >
              {this.state.searchText}
            </Button>
          </div>
        </div>
        {this.state.showDetails ? (
          <form className="form-style" id="dataForm">
            <div className="row data-row">
              <div className="col-md-2 label-class"></div>
              <div className="col-md-1 label-class"></div>
              <div className="col-md-8 select-bordered-div">
                <table class="table">
                  {/* <thead>
                  <tr>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                  </tr>
                </thead> */}
                  <tbody>
                    <tr>
                      <td>Mobile</td>
                      <td>{this.state.searchData.mobile}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{this.state.searchData.email}</td>
                    </tr>
                    <tr>
                      <td>First Name</td>
                      <td>{this.state.searchData.firstName}</td>
                    </tr>
                    <tr>
                      <td>Last Name</td>
                      <td>{this.state.searchData.lastName}</td>
                    </tr>
                    <tr>
                      <td>User Name</td>
                      <td>{this.state.searchData.userName}</td>
                    </tr>
                    <tr>
                      <td>User Type</td>
                      <td>{this.state.searchData.userType.join()}</td>
                    </tr>
                    <tr>
                      <td>Client Name</td>
                      <td>{this.state.searchData.clientName}</td>
                    </tr>
                    <tr>
                      <td>Apps List</td>
                      <td>
                        {this.state.searchData.apps.map(app => {
                          return <span>{app},&nbsp;</span>;
                        })}
                      </td>
                    </tr>
                    <tr>
                      <td>Assigned Projects</td>
                      <td>
                        {this.state.searchData.projects.map(proj => {
                          return <span>{proj},&nbsp;</span>;
                        })}
                      </td>{" "}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-1 label-class"></div>
            </div>

            <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text"> Agent Role</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  {/* <TextField
                    fullWidth
                    // label="Select State"
                    name="state"
                    // label="Client Name"
                    onChange={e => {
                      this.setState({ agentRole: e.target.value });
                    }}
                    select
                    // eslint-disable-next-line react/jsx-sort-props
                    SelectProps={{ native: true }}
                    // value={values.state}
                    variant="outlined"
                  >
                    <option value=""> Select Role </option>
                    <option value="CLNT_AGENT"> Client Agent</option>
                    <option value="CLNT_VERIFIER"> Client Verifier </option>
                    <option value="CLNT_SUPERVISOR">Client Supervisor</option>
                  </TextField> */}
                  <RolesHook/>
                </Grid>
              </div>
            </div>

            {/* <div className="row data-row">
              <div className="col-md-2 label-class">
                <span className="label-text">Client</span>
              </div>
              <div className="col-md-10 select-bordered-div">
                <Grid item md={12} xs={12}>
                  <TextField
                    fullWidth
                    name="state"
                    label="Client"
                    type="text"
                    onChange={e => {
                      this.setState({ client: e.target.value });
                    }}
                    value={this.state.client}
                    variant="outlined"
                  ></TextField>
                </Grid>
              </div>
            </div> */}

            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  onClick={this.submitAgent.bind(this)}
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export function RolesHook() {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete({
    id: "customized-hook-demo",
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: self.state.rolesList,
    getOptionLabel: option => option.title
  });
  console.log(value, "valueoo apps");
  console.log(focused, "focusedoo");
  selectedRolesNew = [...value];

  return (
    <NoSsr>
      <div>
        <div {...getRootProps()}>
          {/* <Label {...getInputLabelProps()}>Customized hook</Label> */}
          <InputWrapper
            ref={setAnchorEl}
            className={focused ? "focused" : ""}
            style={{ width: "100%", height: "3em" }}
          >
            {value.map((option, index) => (
              <Tag label={option.title} {...getTagProps({ index })} />
            ))}

            <input {...getInputProps()} />
          </InputWrapper>
        </div>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()} style={{ "z-index": "2" }}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.title}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </div>
    </NoSsr>
  );
}